/// <reference path="../../typings/index.d.ts" />

import { Utils } from '../Utils';
import * as _ from "underscore";

const defaultOptions = {
    width: 450,
    height: 400,
    showTitle: true,
    visible: false,
    dragEnabled: true,
    closeOnOutsideClick: false,
    showCloseButton: true,
    onHidden: (e) => {
        //this.hide();
    }
};

export class Popup {
    public static popup: DevExpress.ui.dxPopup = null;
    mPopup: DevExpress.ui.dxPopup;
    uniqId: string;

    constructor(popupOptions: DevExpress.ui.dxPopupOptions) {
        _.assign(defaultOptions, popupOptions);
        this.uniqId = Utils.randomId('popup');
        let div = $('<div id="' + this.uniqId + '"/>').appendTo($("#popup"));
        this.mPopup = div.dxPopup(defaultOptions).dxPopup("instance");
    }

    hide() {
        $("#" + this.uniqId).remove();
    }

    show() {
        this.mPopup.show();
    }
}




// WEBPACK FOOTER //
// ./TS/Plan/Popup.ts